const sv = {
  // Common
  save: 'Spara',
  cancel: 'Avbryt',
  delete: 'Ta bort',
  edit: 'Ändra',
  close: 'Stäng',
  loading: 'Laddar...',
  saving: 'Sparar...',
  
  // Auth
  login: 'Logga in',
  logout: 'Logga ut',
  register: 'Skapa konto',
  email: 'E-post',
  password: 'Lösenord',
  name: 'Namn',
  loginSubtitle: 'Logga in för att fortsätta till FlowFocus',
  registerSubtitle: 'Kom igång med FlowFocus idag',
  noAccount: 'Inget konto?',
  hasAccount: 'Har du redan ett konto?',
  createAccount: 'Skapa konto',
  
  // Sidebar
  all: 'Alla',
  inbox: 'Inbox',
  today: 'Idag',
  starred: 'Stjärnmärkta',
  done: 'Klara',
  admin: 'Admin',
  helpGuide: 'Hjälp & Guide',
  upgradePro: 'Uppgradera till Pro',
  quickStats: 'Snabbstatistik',
  total: 'Totalt',
  inProgress: 'Pågående',
  doneToday: 'Klara idag',
  personal: 'Personlig',
  shared: 'Delad',
  
  // Dashboard
  allTasks: 'Alla uppgifter',
  todayTasks: 'Idag',
  starredTasks: 'Stjärnmärkta',
  doneTasks: 'Klara',
  inboxTasks: 'Inbox',
  tasks: 'uppgifter',
  of: 'av',
  
  // Quick Capture
  quickCapturePlaceholder: 'Dumpa uppgift... tryck Enter',
  
  // Today Focus
  todayFocus: 'Dagens fokus',
  noFocusTasks: 'Inga fokusuppgifter valda. Klicka på stjärnan på en uppgift för att lägga till den här.',
  
  // Kanban
  nextUp: 'Next Up',
  dragHere: 'Dra uppgifter hit',
  
  // Task
  priority: 'Prioritet',
  low: 'Låg',
  medium: 'Medium',
  high: 'Hög',
  tag: 'Tagg',
  noTag: 'Ingen tagg',
  description: 'Beskrivning',
  createdAt: 'Skapad',
  createdBy: 'Skapad av',
  
  // Workspace Settings
  workspaceSettings: 'Workspace-inställningar',
  workspaceName: 'Workspace-namn',
  workspaceIcon: 'Workspace-ikon',
  members: 'Medlemmar',
  owner: 'Ägare',
  member: 'Medlem',
  inviteMember: 'Bjud in medlem',
  invite: 'Bjud in',
  
  // Workspace Info
  workspaceInfo: 'Workspace-info',
  noInfoYet: 'Ingen info ännu',
  addInfoDesc: 'Lägg till länkar, lösenord och anteckningar för detta workspace',
  addField: 'Lägg till fält',
  website: 'Webbsida',
  testEnv: 'Testmiljö',
  passwordField: 'Lösenord',
  emailField: 'E-post',
  note: 'Anteckning',
  infoSaved: 'Info sparad',
  
  // Profile
  editProfile: 'Redigera profil',
  roleTitle: 'Roll / Titel',
  rolePlaceholder: 't.ex. Projektledare, VD, Utvecklare',
  showsBelowName: 'Visas under ditt namn i sidofältet',
  emailCantChange: 'Email kan inte ändras',
  clickToChangeAvatar: 'Klicka för att byta profilbild',
  profileUpdated: 'Profil uppdaterad',
  imageMaxSize: 'Bilden får max vara 2 MB',
  avatarUpdated: 'Profilbild uppdaterad',
  
  // Filters
  manageTags: 'Hantera taggar',
  allFilter: 'Alla',
  
  // AI
  aiAssistant: 'FlowFocus AI',
  aiLocked: 'AI-assistenten kräver Pro',
  aiLockedDesc: 'Få hjälp att bryta ner tasks, prioritera och planera din dag med GPT-5.2.',
  aiPlaceholder: 'Fråga mig om dina tasks...',
  aiGreeting: 'Hej! Jag kan hjälpa dig med dina tasks.',
  planMyDay: 'Planera min dag',
  prioritizeTasks: 'Prioritera tasks',
  breakdownTask: 'Bryt ner en task',
  
  // Upgrade
  upgradeTitle: 'Uppgradera till Pro',
  alreadyPro: 'Du har redan Pro-planen!',
  upgradeBtn: 'Uppgradera till Pro — 199 kr/mån',
  perMonth: '/mån',
  popular: 'POPULÄR',
  free: 'Free',
  pro: 'Pro',
  freeDesc: 'Perfekt för att komma igång',
  proDesc: 'För dig som menar allvar med produktivitet',
  
  // Free features
  feat1Workspace: '1 workspace',
  feat2Invites: '2 inbjudningar',
  featKanban: 'Kanban-board med drag & drop',
  featQuickCapture: 'Quick Capture',
  featTags: 'Taggar & filter',
  featFocus: 'Dagens fokus',
  
  // Pro features
  featUnlimitedWs: 'Obegränsat workspaces',
  featUnlimitedInv: 'Obegränsade inbjudningar',
  featAI: 'AI-assistent (GPT-5.2)',
  featBreakdown: 'Task breakdown & prioritering',
  featPlanning: 'Daglig planeringshjälp',
  featAllFree: 'Allt i Free-planen',
  
  // Help Guide
  helpTitle: 'Så funkar FlowFocus',
  helpIntro: 'FlowFocus hjälper dig',
  helpCapture: 'fånga idéer snabbt',
  helpOrganize: 'organisera dem visuellt',
  helpFocus: 'fokusera på det viktigaste',
  
  // Onboarding
  step: 'Steg',
  onboardingOf: 'av',
  next: 'Nästa',
  done_btn: 'Klar!',
  onb1Title: 'Dumpa allt ur huvudet',
  onb1Desc: 'Skriv en tanke, uppgift eller idé och tryck Enter. Den hamnar direkt i Inbox. Sortera sen.',
  onb2Title: 'Dra & organisera',
  onb2Desc: 'Dra uppgifter mellan kolumnerna: Inbox → Next Up → In Progress → Done. Se din progress visuellt.',
  onb3Title: 'Fokusera på rätt saker',
  onb3Desc: 'Stjärnmarkera det viktigaste. Välj max 3 fokusuppgifter per dag. Mindre overwhelm, mer görande.',
  
  // Landing Page
  landingTagline: 'Designad for fokus & flow',
  landingH1_1: 'Task manager för',
  landingH1_2: ' hjärnor med många idéer',
  landingSubtitle: 'Fånga tankar snabbt. Organisera visuellt. Fokusera på det viktiga. FlowFocus hjälper dig gå från överväldigad till i kontroll.',
  startFree: 'Starta gratis',
  seePricing: 'Se priser',
  benefit1: 'Reducera mental overwhelm',
  benefit2: 'Gå från tänkande till görande',
  benefit3: 'Håll koll på flera projekt',
  benefit4: 'Perfekt för ADHD-hjärnor',
  benefit5: 'Samarbeta utan kaos',
  featuresTitle: 'Allt du behöver för att hålla fokus',
  featuresSubtitle: 'Enkla verktyg som fungerar tillsammans för att hjälpa dig exekvera',
  howTitle: 'Så enkelt funkar det',
  step1: 'Dumpa',
  step1Desc: 'Skriv allt som dyker upp i huvudet. Tryck Enter.',
  step2: 'Organisera',
  step2Desc: 'Dra till rätt kolumn. Lägg till taggar.',
  step3: 'Fokusera',
  step3Desc: 'Välj dagens 3 viktigaste. Stjärnmarkera.',
  step4: 'Exekvera',
  step4Desc: 'Gör. Dra till Done. Repeat.',
  pricingTitle: 'Enkel prissättning',
  pricingSubtitle: 'Börja gratis. Uppgradera när du behöver mer.',
  startWithPro: 'Starta med Pro',
  ctaTitle: 'Redo att ta kontroll?',
  ctaSubtitle: 'Börja gratis. Inga kreditkort. Uppgradera när du vill.',
  createAccountFree: 'Skapa konto gratis',
  pricing: 'Priser',
  
  // Feature cards
  featCaptureTitle: 'Snabb Capture',
  featCaptureDesc: 'Dumpa tankar direkt. Tryck Enter och det hamnar i Inbox. Sortera sen.',
  featKanbanTitle: 'Visuellt Kanban-flöde',
  featKanbanDesc: 'Dra uppgifter mellan Inbox, Next Up, In Progress och Done.',
  featFocusTitle: 'Fokusera på rätt saker',
  featFocusDesc: 'Stjärnmarkera viktigt. Välj 3 fokusuppgifter för dagen.',
  featCollabTitle: 'Samarbeta enkelt',
  featCollabDesc: 'Bjud in teammedlemmar till workspaces. Se vem som skapat vad.',
  featTrackTitle: 'Spåra över tid',
  featTrackDesc: 'Se när tasks skapades. Filtrera på tid, prioritet, taggar.',
  featAITitle: 'AI-assistent',
  featAIDesc: 'Bryt ner tasks, få prioriteringshjälp och daglig planering med GPT-5.2.',
  
  // Invite page
  inviteTitle: 'Workspace-inbjudan',
  inviteAccepting: 'Accepterar inbjudan...',
  inviteSuccess: 'Du har gått med i workspacet!',
  inviteGoToDashboard: 'Gå till Dashboard',
  inviteLoginFirst: 'Logga in för att acceptera inbjudan',
};

export default sv;
